<template lang="pug">
div
  div.d-flex.justify-center.mt-16(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
  template(v-else-if="appointments.length")
    template(v-for="(appointment, index) in appointments")
      div.px-8(:key="`appt-${appointment.id}`")
        appointment-view(:appointment="appointment" :index="index")
      v-divider.neutral400.my-6
    div.px-8(v-if="showAddAppointmentForm")
      appointment-form(ref="forms")
    div.add-box.mt-6.mx-8.pa-8(v-else align="center" @click="showAddAppointmentForm = true")
      v-avatar(color="neutral300" size="56")
        v-icon(color="neutral500" size="40") $yzi-calendar-tick
      div.text-center.text-md.font-semibold.neutral700--text.mt-1 Add more appointment
      div.text-center.text-sm.font-normal.neutral700--text.mt-1 Add series of appointments or chained appointments for patients with ease. 
    
  div.px-8(v-else)
    appointment-form(ref="forms")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppointmentForm from '@/components/clinic/appointment/advance/AppointmentForm.vue'
import AppointmentView from '@/components/clinic/appointment/advance/AppointmentView.vue'

export default {
  components: { AppointmentForm, AppointmentView },
  props: ['showForm', 'selectedAppointment'],
  data () {
    return {
      isFetching: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      appointment: 'clinic/getTempAppointment',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    showAddAppointmentForm: {
      get () {
        return this.showForm
      },
      set (val) {
        this.$emit('update:showForm', val)
      }
    },
    appointments () {
      let appts = []
      if (this.appointment.appointments && this.appointment.appointments.length) {
        appts = this.appointment.appointments
      }
      return appts
    }
  },
  mounted () {
    if (this.selectedAppointment) {
      this.fetchAppointmentSeries()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchAppointmentSeries () {
      this.isFetching = true
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/appointments/series`, { params : { serial_no: this.selectedAppointment.serial_no } })
        .then(resp => {
          let appointments = resp.data.results
          let data = {
            appointments: appointments,
            serial_no: this.selectedAppointment.serial_no
          }
          this.$store.commit('clinic/updateTempAppointment', data)
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-box {
  cursor: pointer;
  border-radius: 10px;
  border: var(--v-neutral400) dashed 2px;
  background-color: var(--v-neutral200);
}
</style>